import { render, staticRenderFns } from "./editOrderBuy.vue?vue&type=template&id=2d447474&"
import script from "./editOrderBuy.vue?vue&type=script&lang=js&"
export * from "./editOrderBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports